import { useCallback, useContext } from 'react';

import {
  IconButton,
  Icons,
  MetadataChipV2,
  notify,
  PageHeader,
  Skeleton,
  Stack,
  Tooltip,
} from '@cast/design-system';
import {
  WorkloadDetailsContext,
  WorkloadStatus,
} from '@cast/split-me/features/cluster/workload-optimization';

import { usePodListDrawer } from '../meta/_components/usePodListDrawer';

export const InventoryWorkloadDetailsHeader = () => {
  const { workload, pods } = useContext(WorkloadDetailsContext);
  const { openPodListDrawer } = usePodListDrawer();

  const handleCopyId = useCallback(() => {
    if (workload?.id) {
      void navigator.clipboard.writeText(workload.id).then(() => {
        notify.success('Copied to clipboard');
      });
    }
  }, [workload?.id]);

  if (!workload) {
    return <Skeleton height={100} width="100%" />;
  }

  return (
    <PageHeader
      heading={workload.name}
      suffix={
        <Tooltip title="Copy workload ID">
          <IconButton
            variant="ghost"
            size="md"
            aria-label="Copy workload ID"
            onClick={handleCopyId}
            testId="workload-header-copy-id"
          >
            <Icons.Copy />
          </IconButton>
        </Tooltip>
      }
      metadata={
        <Stack direction="row" gap={8} alignItems="center">
          <WorkloadStatus
            testId="workload-details-status"
            workload={workload}
            onAppliedStatusClick={() => {
              openPodListDrawer({ pods: pods ?? [] });
            }}
          />
          <MetadataChipV2
            size="l"
            variant="subtle"
            label={`Namespace: ${workload.namespace}`}
            testId="workload-header-namespace"
          />
        </Stack>
      }
      testId="inventory-workload-details-header"
    />
  );
};
